// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-forms-EditTitleLabelBox-EditTitleLabelBox-module__container-hSX7Pa","title":"src-app-components-forms-EditTitleLabelBox-EditTitleLabelBox-module__title-Q2xSNo","need":"src-app-components-forms-EditTitleLabelBox-EditTitleLabelBox-module__need-T_f2UO","footer":"src-app-components-forms-EditTitleLabelBox-EditTitleLabelBox-module__footer-SUSWwZ","textField":"src-app-components-forms-EditTitleLabelBox-EditTitleLabelBox-module__textField-S9gy0F"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-forms-EditTitleLabelBox-EditTitleLabelBox-module__container-hSX7Pa\",\"title\":\"src-app-components-forms-EditTitleLabelBox-EditTitleLabelBox-module__title-Q2xSNo\",\"need\":\"src-app-components-forms-EditTitleLabelBox-EditTitleLabelBox-module__need-T_f2UO\",\"footer\":\"src-app-components-forms-EditTitleLabelBox-EditTitleLabelBox-module__footer-SUSWwZ\",\"textField\":\"src-app-components-forms-EditTitleLabelBox-EditTitleLabelBox-module__textField-S9gy0F\"}";
        // 1789362522821
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  